module.exports = __webpack_public_path__ + "media/images/emblems/Neunforn-blazon-ebe5c292c372452536a3b27a57d53071.svg";